import React, { useEffect } from "react";
import { useNotificationsCenter } from "../../contexts/NotificationsContext";
import { UserNotification } from "../../types/api";
import { NotificationMessage } from "./NotificationMessage";
import { NotificationEventIcon } from "./NotificationEventIcon";

const AUTO_DISMISS_MS = 10000;

interface ToastItemProps {
    notification: UserNotification;
    onClose: (id: number, markRead: boolean) => void;
    onOpen: (patientId: number) => void;
}

const ToastItem: React.FC<ToastItemProps> = ({ notification, onClose, onOpen }) => {
    useEffect(() => {
        // Auto-dismiss after 10s; this path leaves the notification UNREAD in the center.
        const timer = setTimeout(() => onClose(notification.id, false), AUTO_DISMISS_MS);
        return () => clearTimeout(timer);
    }, [notification.id, onClose]);

    return (
        <div
            dir="rtl"
            style={{
                width: 360,
                backgroundColor: "#fff",
                borderRadius: 8,
                boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
                border: "1px solid #B4D9D4",
                overflow: "hidden",
                pointerEvents: "auto",
            }}
        >
            {/* Top bar with manual close (marks read) */}
            <div
                style={{
                    backgroundColor: "#3b5d6b",
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    padding: "0 8px",
                }}
            >
                <button
                    onClick={() => onClose(notification.id, true)}
                    title="סגור"
                    aria-label="סגור"
                    style={{
                        background: "transparent",
                        border: "none",
                        color: "#fff",
                        cursor: "pointer",
                        fontSize: 16,
                        lineHeight: 1,
                        padding: 2,
                    }}
                >
                    ✕
                </button>
            </div>

            {/* Body: clicking navigates to the patient page */}
            <div
                onClick={() => onOpen(notification.patient_id)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    padding: "12px 14px",
                    cursor: "pointer",
                }}
            >
                <NotificationEventIcon event={notification.notification_event} />
                <span style={{ fontSize: 14, color: "#1f2937", lineHeight: 1.4, textAlign: "right" }}>
                    <NotificationMessage
                        message={notification.message}
                        patientName={notification.patient_name}
                        onOpenPatient={() => onOpen(notification.patient_id)}
                    />
                </span>
            </div>
        </div>
    );
};

export const NotificationToast: React.FC = () => {
    const { toasts, dismissToast, openPatient } = useNotificationsCenter();

    if (toasts.length === 0) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 70,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 2000,
                display: "flex",
                flexDirection: "column",
                gap: 10,
                pointerEvents: "none",
            }}
        >
            {toasts.map((n) => (
                <ToastItem
                    key={n.id}
                    notification={n}
                    onClose={dismissToast}
                    onOpen={openPatient}
                />
            ))}
        </div>
    );
};
